import React from 'react';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { ISupplierModel } from '../../../Supplier/types';
import { Avatar, AvatarSize } from '../../../../DesignSystem/VendorProfile/Avatar';
import Heading from '../../../../generic-components/Heading';
import { getAddressDetails } from '../../../Supplier/helpers';
import { ReactComponent as AddressIcon } from '../../../../assets/svg/location-pin.svg';
import { ReactComponent as EditIcon } from '../../../../assets/svg/edit-pen.svg';

interface IVendorsListProps {
    vendorList: ISupplierModel[];
    onVendorSelection: (vendorData: ISupplierModel) => void;
    onEditVendor: (e: React.MouseEvent<HTMLButtonElement>, vendorData: ISupplierModel) => void;
}

export const VendorsList = (props: IVendorsListProps) => {
  const { vendorList, onVendorSelection, onEditVendor } = props;
  return (
    <div className='w-[395px] py-[10px] grow mx-auto no-scrollbar no-scrollbar::-webkit-scrollbar'>
      {vendorList.map((supplier: ISupplierModel) => (
        <button id={`payeeItem-${supplier.supplierId}`} onClick={() => onVendorSelection(supplier)} type='button' className='w-full'>
          <div
            className='w-full flex items-center hover:bg-bw02 active:bg-bw03 transition-all ease-in px-[10px] py-[10px] rounded-[8px] mb-[10px]'
          >
            <div className='flex items-center gap-[10px]'>
              <Avatar name={supplier.name} id={supplier.supplierId || ''} size={AvatarSize.LARGE} />
              <div className='flex flex-col'>
                <Heading
                  title={supplier.name}
                  className='font-metricRMedium w-fit text-bw08 text-[16px] max-w-[240px] truncate'
                />
                {supplier.supplierAddressData?.line1 && (
                <div className='flex items-center gap-[4px]'>
                  <AddressIcon />
                  <Heading
                    title={getAddressDetails(supplier?.supplierAddressData)}
                    className='font-metricR max-w-[240px] truncate text-bw07 text-[14px]'
                  />
                </div>
                )}
              </div>
            </div>
            <div className='ml-auto'>
              <LiliButton
                onClick={(e) => onEditVendor(e, supplier)}
                id={`editPayee-${supplier.supplierId}`}
                className='w-fit'
                icon={<EditIcon />}
                type={LiliButtonType.SKIP}
              />
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};
